export const TextSMSModal: string = 'TextSMSModal';
